import React from 'react';
import PdfViewer from './PdfViewer';
import Footer from './Footer'; 

const HomePage = () => {
  const backgroundImage = "url('/bgwhite.jpg')";

  const openFullscreen = () => {
    const elem = document.documentElement;
    if (elem.requestFullscreen) {
      elem.requestFullscreen();
    } else if (elem.mozRequestFullScreen) {
      elem.mozRequestFullScreen();
    } else if (elem.webkitRequestFullscreen) {
      elem.webkitRequestFullscreen();
    } else if (elem.msRequestFullscreen) {
      elem.msRequestFullscreen();
    } else {
      alert('Fullscreen API is not supported on this browser.');
    }
  };

  return (
    <div
      className="flex flex-col w-screen h-screen bg-center bg-no-repeat bg-cover"
      style={{ backgroundImage, overflow: 'hidden' }}
    >
      {/* 🔵 Header */}
      <div className="flex items-center justify-center gap-4 bg-white p-2 w-full">
        <img
          src="/Antipolo_City_Logo.png"
          alt="Antipolo City Logo"
          className="w-24 h-auto"
          draggable={false}
        />
        <h1 className="text-3xl font-bold text-center">
          CITY GOVERNMENT OF ANTIPOLO - FULL DISCLOSURE
        </h1>
        <button onClick={openFullscreen} className="w-48 h-auto">
          <img
            src="/tayona.png"
            alt="Tayo Na"
            className="w-48 h-auto"
            draggable={false}
          />
        </button>
        

 



      </div>

      {/* 🔵 Content */}
      <div className="flex-1 overflow-auto">
        <PdfViewer />
      </div>

      <Footer /> 


    </div>
  );
};

export default HomePage;
